export function IconButton({ icon, onClick }) {
  return (
    <div
      className="p-3 bg-slate-100 hover:bg-slate-200 rounded-md text-xl cursor-pointer"
      onClick={onClick}
    >
      {icon}
    </div>
  );
}
